import selection from "./selection";
import uptFile from "./uptFile";
const _ = require("lodash");

class Clipboard {
  constructor() {
    this.indexes = [];
    this.values = [];
    this.rangeX = 0;
    this.rangeY = 0;
    this.driveTypes = [];
    this.type = "undefined";
  }

  resetClipboard() {
    this.indexes = [];
    this.values = [];
    this.rangeX = 0;
    this.rangeY = 0;
    this.driveTypes = [];
    this.type = "undefined";
  }

  setCopy(indexes, values, rangeX, rangeY, driveTypes) {
    this.type = "undefined";
    this.indexes = indexes;
    this.values = values;
    this.rangeX = rangeX;
    this.rangeY = rangeY;
    this.driveTypes = driveTypes;
  }

  setCopyPicksOnly(pickIndexes, pickValues) {
    this.type = "picks";
    this.indexes = pickIndexes;
    this.values = pickValues;
    this.rangeY = _.max(pickIndexes) - _.min(pickIndexes) + 1;
  }

  setCopyDrivesOnly(driveIndexes, driveValues, driveTypes) {
    this.type = "drives";
    this.indexes = driveIndexes;
    this.values = driveValues;
    this.rangeX = _.max(driveIndexes) - _.min(driveIndexes) + 1;
    this.driveTypes = driveTypes;
  }

  isPasteDisabled() {
    if (_.isEmpty(this.values) || selection.selectionList.length === 0) {
      return true;
    }
    switch (this.type) {
      case "picks":
        if (selection.selectionList.length === 1) {
          const numberOfPicks = uptFile.xmlData.patternPicksCount;
          return (
            selection.selectionList[0][0] + this.rangeY >= numberOfPicks + 1
          );
        } else {
          const pickIndexes = _.sortBy(
            _.uniq(selection.selectionList.map(s => s[0]))
          );
          const relativePickIndexes = pickIndexes.map(p => p - pickIndexes[0]);
          return !_.isEqual(relativePickIndexes, this.indexes);
        }
      /* falls through */
      case "drives":
        if (selection.selectionList.length === 1) {
          const startDriveIndex = selection.selectionList[0][1];
          let result = false;
          this.driveTypes.forEach((d, i) => {
            if (
              uptFile.pickData.driveData.tagNames[startDriveIndex + i] !== d
            ) {
              result = true;
            }
          });
          return result;
        } else {
          if (!selection.isSelectionDrivesOnly()) {
            return true;
          }
          const driveIndexes = _.sortBy(
            _.uniq(selection.selectionList.map(s => s[1]))
          );
          const driveTypes = driveIndexes.map(
            d => uptFile.pickData.driveData.tagNames[d]
          );
          return !_.isEqual(driveTypes, this.driveTypes);
        }
      /* falls through */
      case "undefined":
        if (selection.selectionList.length === 1) {
          const numberOfPicks = uptFile.xmlData.patternPicksCount;
          const picksInRange =
            selection.selectionList[0][0] + this.rangeY <= numberOfPicks;
          const numberOfDrives = uptFile.pickData.driveData.tagNames.length;
          const drivesInRange =
            selection.selectionList[0][1] + this.rangeX <= numberOfDrives;
          let drivesAreCorrect = true;
          this.driveTypes.forEach(d => {
            const driveIndex = selection.selectionList[0][1] + d.index;
            if (
              !_.isEqual(
                d.type,
                uptFile.pickData.driveData.tagNames[driveIndex]
              )
            ) {
              drivesAreCorrect = false;
            }
          });
          return !(picksInRange && drivesInRange && drivesAreCorrect);
        } else {
          if (selection.selectionList.length !== this.values.length) {
            return true;
          }
          const sortedIndexes = _.sortBy(selection.selectionList);
          const pickIndexes = sortedIndexes.map(i => i[0]);
          const minPickIndex = _.min(pickIndexes);
          const driveIndexes = sortedIndexes.map(i => i[1]);
          const minDriveIndex = _.min(driveIndexes);
          const relativeSortedIndexes = sortedIndexes.map(i => [
            i[0] - minPickIndex,
            i[1] - minDriveIndex
          ]);
          const driveTypes = _.sortBy(_.uniq(driveIndexes)).map(d => {
            return {
              index: d,
              type: uptFile.pickData.driveData.tagNames[d]
            };
          });
          return !(
            _.isEqual(relativeSortedIndexes, this.indexes) &&
            _.isEqual(driveTypes, this.driveTypes)
          );
        }
      /* falls through */
      default:
        return true;
    }
  }
}

const clipboard = new Clipboard();

export default clipboard;
